export const NEXT_AVAILABLE_TIME = 'NEXT_AVAILABLE_TIME';